(function($) {
  var $header = $('.site-header');
  var y = 0;
  var d = 0;
  var upOffset = 60;

  $(window).on('scroll resize load', () => {
    var winY = window.scrollY || window.pageYOffset;
    var offset = 0;

    if ('absolute' == $('#wpadminbar').css('position')) {
      offset += $('#wpadminbar').height();
    }

    if (winY >= offset) {
      $header.addClass('fixed');
    } else {
      $header.removeClass('fixed');
    }

    if (y < winY && winY >= 300) {
      $header.addClass('mini')
      $header.triggerHandler('mini');
      d = winY;
    } else {
      if ( d - upOffset > winY ) {
        $header.removeClass('mini')
        $header.triggerHandler('full');
      }
    }

    y = winY;
  });
})(jQuery);